module.exports = __webpack_public_path__ + "img/tf.4a384446.svg";